import React from 'react';

// Render inline **bold** spans within a line of legal text.
const renderInline = (text) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} className="font-semibold text-slate-900 dark:text-white">{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

// Lightweight markdown renderer tuned for the EnsueLIVETRAK legal documents:
// headings (#, ##, ###), bullet lists (*) and paragraphs (incl. a./b./c. items).
export const LegalContent = ({ markdown }) => {
  const lines = (markdown || '').split('\n');
  const blocks = [];
  let bullets = [];
  const flushBullets = () => {
    if (bullets.length) {
      blocks.push({ type: 'ul', items: bullets });
      bullets = [];
    }
  };

  lines.forEach((raw) => {
    const t = raw.trim();
    if (!t) { flushBullets(); return; }
    if (t.startsWith('### ')) { flushBullets(); blocks.push({ type: 'h3', text: t.slice(4) }); return; }
    if (t.startsWith('## ')) { flushBullets(); blocks.push({ type: 'h2', text: t.slice(3) }); return; }
    if (t.startsWith('# ')) { flushBullets(); blocks.push({ type: 'h1', text: t.slice(2) }); return; }
    if (t.startsWith('* ') || t.startsWith('- ')) { bullets.push(t.slice(2)); return; }
    flushBullets();
    blocks.push({ type: 'p', text: t });
  });
  flushBullets();

  return (
    <div className="space-y-3 text-sm leading-relaxed text-slate-700 dark:text-slate-300">
      {blocks.map((b, i) => {
        if (b.type === 'h1') {
          return <h1 key={i} className="text-xl font-bold text-slate-900 dark:text-white">{renderInline(b.text)}</h1>;
        }
        if (b.type === 'h2') {
          return (
            <h2 key={i} className="text-base font-semibold text-slate-900 dark:text-white mt-5 pt-3 border-t border-slate-100 dark:border-slate-800">
              {renderInline(b.text)}
            </h2>
          );
        }
        if (b.type === 'h3') {
          return <h3 key={i} className="text-sm font-semibold text-slate-800 dark:text-slate-200 mt-3">{renderInline(b.text)}</h3>;
        }
        if (b.type === 'ul') {
          return (
            <ul key={i} className="list-disc pl-5 space-y-1.5">
              {b.items.map((it, j) => <li key={j}>{renderInline(it)}</li>)}
            </ul>
          );
        }
        return <p key={i}>{renderInline(b.text)}</p>;
      })}
    </div>
  );
};
